const PREFIX = 'oaits'

export const storage = {
    get(key, fallback = null) {
        try {
            const raw = localStorage.getItem(`${PREFIX}.${key}`)

            if (raw === null) {
                return fallback
            }

            return JSON.parse(raw)
        } catch (e) {
            return fallback
        }
    },

    set(key, value) {
        try {
            const safe_value = value === undefined ? null : value

            localStorage.setItem(`${PREFIX}.${key}`, JSON.stringify(safe_value))
        } catch (e) {
            // localStorage недоступен (приватный режим и т.п.) - молча пропускаем
        }
    },

    remove(key) {
        localStorage.removeItem(`${PREFIX}.${key}`)
    }
}
